import { get } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';

proj4.defs(
  'EPSG:2154',
  '+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
);

register(proj4);

export const proj2154 = get('EPSG:2154');
export const proj3857 = get('EPSG:3857');
export const proj4326 = get('EPSG:4326');
